import en from './en.json';
import fr from './fr.json';
import nl from './nl.json';
const translations = {
  en,
  fr,
  nl
};
export default translations;
